export const KNOWLEDGE = {
  LIST_KNOWLEDGE_START: 'KNOWLEDGE/LIST_KNOWLEDGE_START',
  LIST_KNOWLEDGE_SUCCEEDED: 'KNOWLEDGE/LIST_KNOWLEDGE_SUCCEEDED',
  LIST_KNOWLEDGE_FAILED: 'KNOWLEDGE/LIST_KNOWLEDGE_FAILED',
  KB_BASE: 'ARTICLE',
  KB_SUPPORT_ARTICLE: 'SUPPORT ARTICLE',
  ANNOUNCEMENTS: 'Announcements',
  OUTAGE: 'OUTAGE',
  KB_PC_REFRESH: 'KB_PC_REFRESH',
  KB_PC_RETURN: 'KB_PC_RETURN',
  KB_PC_COST: 'KB_PC_COST',
  ANNOUNCEMENT_ARTICLE: 'ANNOUNCEMENT_ARTICLE',
  FEATURE_ARTICLE: 'FEATURE_ARTICLE'
};
